import { useState } from "react";
import VoiceCard from "../BusinessWizardSteps/VoiceCard";
import { useEffect } from "react";

const AdMusic = (props) => {

    const [selectedMusic, setSelectedMusic] = useState(null)

    useEffect(() => {
        const isValidMusic = props.music.find(music => music.id == props.selectedModalObject.musicId)?.name

        if (isValidMusic) {
            setSelectedMusic(isValidMusic)
        } else {
            setSelectedMusic(null)
        }
    }, [props.selectedModalObject.musicId])

    return (
        <div className="formStyle pt-2">
            <p className="pl-4">Choose from our library of music.</p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
                {props.music.map((e, index) => {
                    return (
                        <div style={{ width: "47%", backgroundColor: "" }}>
                            <VoiceCard voiceData={e} index={index} colorSchemeTheme={"dark"} selectedVoice={selectedMusic && selectedMusic} isAdMusic={true} setSelectedModalObject={props.setSelectedModalObject} selectedModalObject={props.selectedModalObject} showId={false} handlePreviewVoice={props.handlePreviewVoice} currentPlayingVoice={props.currentPlayingVoice} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default AdMusic